import * as invoiceReducer from './invoicesReducer';
import * as invoicesListDownloadReducer from './invoicesListDownloadReducer';

const Reducers = {
  ...invoiceReducer,
  ...invoicesListDownloadReducer,
};

export default Reducers;
